import ClipboardJS from 'clipboard';

export default {
    init() {
        // JavaScript to be fired on the home page

        let buttonSurveyCode = document.querySelector('#copyClipboardButton');
        let scrollBtnSurvey = $('section.banner-survey .scroll-text');

        if (buttonSurveyCode) {

          var clipboardSurvey = new ClipboardJS(buttonSurveyCode);

          $(buttonSurveyCode).on('shown.bs.tooltip', function () {
              $(this).tooltip('disable');
              setTimeout(() => {
                $(this).tooltip('hide');
              }, 1500);
          })

          clipboardSurvey.on('success', function() {
              $(buttonSurveyCode).tooltip('enable');
              $(buttonSurveyCode).tooltip('show');
          });

        }


        // scroll btn to code survey
        if (scrollBtnSurvey) {
          $(scrollBtnSurvey).on('click', function() {
            $('html, body').animate({
              scrollTop: $('section.code-survey').offset().top - $('header').height() - 50,
            }, 500);
          })
        }

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/survey.js